(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-user"]) return;
  try {
    
(function () {
  'use strict';

  const wrap = document.getElementById('mokusen-contact-wrap');
  const form = document.getElementById('mokusen-contact-form');
  const categorySelect = document.getElementById('inquiry-categories');
  const sectionDelivery = document.getElementById('section-delivery');
  const sectionOrder = document.getElementById('section-order');

  function updateConditionalSections() {
    if (!sectionDelivery || !sectionOrder) return;
    const selected = categorySelect && categorySelect.selectedIndex >= 0
      ? categorySelect.options[categorySelect.selectedIndex]
      : null;
    const trigger = selected && selected.dataset ? selected.dataset.trigger : '';
    toggleSection(sectionDelivery, trigger === 'delivery');
    toggleSection(sectionOrder, trigger === 'order');
  }

  function toggleSection(el, show) {
    if (!el) return;
    if (show) {
      el.classList.add('is-visible');
      el.setAttribute('aria-hidden', 'false');
    } else {
      el.classList.remove('is-visible');
      el.setAttribute('aria-hidden', 'true');
    }
  }

  if (categorySelect) {
    categorySelect.addEventListener('change', updateConditionalSections);
  }
  updateConditionalSections();

  function clearErrors() {
    document.querySelectorAll('.mokusen-field-error').forEach(function (el) {
      el.textContent = '';
    });
  }

  function setError(forId, msg) {
    const el = document.querySelector('.mokusen-field-error[data-for="' + forId + '"]');
    if (el) el.textContent = msg;
  }

  function validateForm() {
    clearErrors();
    let valid = true;

    const name = document.getElementById('contact-name');
    if (!name || !name.value.trim()) {
      setError('contact-name', 'お名前を入力してください。');
      valid = false;
    }

    const email = document.getElementById('contact-email');
    if (!email || !email.value.trim()) {
      setError('contact-email', 'メールアドレスを入力してください。');
      valid = false;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value)) {
      setError('contact-email', '正しいメールアドレスを入力してください。');
      valid = false;
    }

    if (!categorySelect || !categorySelect.value) {
      setError('inquiry-categories', 'お問い合わせ項目を選択してください。');
      valid = false;
    }

    const body = document.getElementById('contact-body');
    if (!body || !body.value.trim()) {
      setError('contact-body', 'お問い合わせ内容を入力してください。');
      valid = false;
    }

    const privacy = document.getElementById('contact-privacy');
    if (!privacy || !privacy.checked) {
      setError('contact-privacy', 'プライバシーポリシーへの同意が必要です。');
      valid = false;
    }

    return valid;
  }

  const confirmBtn = document.getElementById('mokusen-confirm-btn');
  const backBtn = document.getElementById('mokusen-back-btn');
  const confirmTable = document.getElementById('mokusen-confirm-table');

  function buildConfirmTable() {
    const rows = [];

    function addRow(label, value) {
      if (value && value.toString().trim()) {
        rows.push({ label: label, value: value });
      }
    }

    addRow('お名前', document.getElementById('contact-name').value);
    addRow('メールアドレス', document.getElementById('contact-email').value);
    addRow('お電話番号', document.getElementById('contact-phone').value);
    addRow('お問い合わせ項目', categorySelect ? categorySelect.value : '');

    if (sectionDelivery && sectionDelivery.classList.contains('is-visible')) {
      addRow('お届け先郵便番号', document.getElementById('contact-postcode').value);
      addRow('お届け先都道府県', document.getElementById('contact-prefecture').value);
      addRow('お届け先市区町村', document.getElementById('contact-city').value);
      const bt = document.querySelector('input[name="contact[building_type]"]:checked');
      addRow('建物の種類', bt ? bt.value : '');
      addRow('お届け先の階数', document.getElementById('contact-floor').value);
      const ev = document.querySelector('input[name="contact[elevator]"]:checked');
      addRow('エレベーター', ev ? ev.value : '');
      addRow('搬入について気になる点', document.getElementById('contact-delivery-note').value);
    }

    if (sectionOrder && sectionOrder.classList.contains('is-visible')) {
      addRow('ご注文番号', document.getElementById('contact-order-number').value);
      addRow('ご注文時のお名前', document.getElementById('contact-order-name').value);
    }

    addRow('商品名・商品番号', document.getElementById('contact-product-name').value);
    addRow('商品ページURL', document.getElementById('contact-product-url').value);
    addRow('お問い合わせ内容', document.getElementById('contact-body').value);
    addRow('プライバシーポリシー', '同意する');

    confirmTable.innerHTML = rows.map(function (r) {
      return '<div class="mokusen-confirm-row">'
        + '<div class="mokusen-confirm-label">' + r.label + '</div>'
        + '<div class="mokusen-confirm-value">' + escapeHtml(r.value) + '</div>'
        + '</div>';
    }).join('');
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  if (confirmBtn) {
    confirmBtn.addEventListener('click', function () {
      if (!validateForm()) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }
      buildConfirmTable();
      if (wrap) wrap.classList.add('mokusen-is-confirming');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  if (backBtn) {
    backBtn.addEventListener('click', function () {
      if (wrap) wrap.classList.remove('mokusen-is-confirming');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  if (form && window.Shopify && window.Shopify.captcha && typeof window.Shopify.captcha.protect === 'function') {
    window.Shopify.captcha.protect(form);
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
